// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dots-line[data-v-531d3333] {\n  width: 100%;\n}\n[dir] .dots-line[data-v-531d3333] {\n  border-bottom: 1px dotted black;\n  margin-bottom: 5px;\n}\n.payment-options-container[data-v-531d3333] {\n  position: sticky;\n  bottom: 0;\n}\n[dir=ltr] .payment-options-container[data-v-531d3333] {\n  right: 0;\n}\n[dir=rtl] .payment-options-container[data-v-531d3333] {\n  left: 0;\n}\n", ""]);
// Exports
module.exports = exports;
